// extracted by mini-css-extract-plugin
export default {"header--sticky":"header--sticky_ve2OyTkW","header--fallback":"header--fallback_Qgl3MnB1"};